import {BehaviorSubject} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {wwData$} from './worker-data';

export const wsStatus$ = new BehaviorSubject<WsStatus>('Init');
export const wsOpening$ = wsStatus$.pipe(filter((x) => x === 'Opening'));
export const wsOpened$ = wsStatus$.pipe(filter((x) => x === 'Opened'));
export const wsConnectTimes$ = new BehaviorSubject(0);
export const wsOpenTimes$ = new BehaviorSubject(0);

wwData$
  .pipe(
    filter((o) => o.type === 'ws-status'),
    map((o) => o.data.status)
  )
  .subscribe((status) => wsStatus$.next(status));

wsOpening$.subscribe(() => wsConnectTimes$.next(wsConnectTimes$.getValue() + 1));
wsOpened$.subscribe(() => {
  wwData$.next({type: 'ty-ready'});
  wsConnectTimes$.next(0);
  wsOpenTimes$.next(wsOpenTimes$.getValue() + 1);
});
